export default __webpack_public_path__ + "static/media/resource-banner-app-mobile.a9220741.png";